import { createContext } from 'react';
import { TLanguageIDs, ILanguages, IWordingsValue, ICreateWording } from 'types';

export type TTypeOfModalWindow = null | 'toConfirmFieldsClearing' | 'toConfirmSubmit' | 'success' | 'error';

export interface IAddWordingsState {
	IDSelectedCategory: string | null;
	key: string;
	fetchedLanguages: ILanguages[];
	translations: IWordingsValue[];
	dataForSubmit: ICreateWording | null;
	typeOfModalWindow: TTypeOfModalWindow;
}

export const addWordingsInitialState: IAddWordingsState = {
	IDSelectedCategory: null,
	key: '',
	fetchedLanguages: [],
	translations: [],
	dataForSubmit: null,
	typeOfModalWindow: null,
};

export interface IAddWordingsContext extends IAddWordingsState {
	setIDCategory(value: string | null): void;
	changeKey(value: string): void;
	changeLabels(languageId: TLanguageIDs, value: string): void;
	changeValues(languageId: TLanguageIDs, value: string): void;
	setDataForSubmit(value: ICreateWording | null): void;
	resetFields(): void;
	changeTypeOfModalWindow(value: TTypeOfModalWindow): void;
}

export const AddWordingsContext = createContext<IAddWordingsContext>({
	setIDCategory: () => undefined,
	changeKey: () => undefined,
	changeLabels: () => undefined,
	changeValues: () => undefined,
	setDataForSubmit: () => undefined,
	resetFields: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	...addWordingsInitialState,
});
